import { TColor } from "../../../type/color-type";

export interface IStatusBadgeItem {
    label: string;
    color: TColor;
}

enum TrainingEmployeeStatusEnum {
    pending,
    done
}

const statusLabels: Record<TrainingEmployeeStatusEnum, string> = {
    [TrainingEmployeeStatusEnum.pending]: 'Pendente',
    [TrainingEmployeeStatusEnum.done]: 'Concluído',
};

const statusColors: Record<TrainingEmployeeStatusEnum, TColor> = {
    [TrainingEmployeeStatusEnum.pending]: 'warning',
    [TrainingEmployeeStatusEnum.done]: 'success',
};

export function getStatusBadge (status: TrainingEmployeeStatusEnum): IStatusBadgeItem {
    return {
        label: statusLabels[status],
        color: statusColors[status],
    };
};

export default TrainingEmployeeStatusEnum;
